import './App.css';
import { Route, Routes } from 'react-router-dom';
import {AuthProvider} from './components/login/contextos/AuthContex';
import PrivateRoute from "./components/PrivateRoute";
import ViewHome from './components/ViewHome';
import ViewLogin from './components/ViewLogin';
import ViewRecordHistory from './components/ViewRecordHistory';
import ViewSiniesterIncome from './components/ViewSiniesterIncome';
import IngresoSiniestro from './components/IngresoSiniestro';
import IngresoPoliza from './components/IngresoPolizaInpaga';
import PolizaInpaga from './components/PolizaInpaga';




const App = () => {
  return (
    <>
    <AuthProvider>
    <Routes>
          <Route path="/" element={<ViewHome />} />
          <Route path="/Login" element={<ViewLogin />} />
          <Route path="/EntrySinister" element={
          <PrivateRoute>
          <IngresoSiniestro />
          </PrivateRoute>} />
          <Route path="/Poliza" element={<IngresoPoliza />} />

          <Route path='/RecordHistory' element={
            <PrivateRoute>
             <ViewRecordHistory />
            </PrivateRoute>
          } />
          <Route path='/SiniesterIncome' element={
            <PrivateRoute>
             <ViewSiniesterIncome />
            </PrivateRoute>
          } />
        <Route path='/PolizaInpaga' element={
            <PrivateRoute>
             <PolizaInpaga />
            </PrivateRoute>
          } />
        </Routes>
    </AuthProvider>
    </>
  );
}
export default App;